import { useEffect } from 'react';

import { Home } from 'features/home/Home';
import { ROUTE_HOME } from 'navigation/config/routePaths';
import { useAuth } from 'providers/AuthProvider';

import { useLoginPopup } from './login/useLoginPopup';

export const Login = () => {
  const { logged } = useAuth();
  const { showLoginPopup } = useLoginPopup();

  useEffect(() => {
    window.history.replaceState(null, '', ROUTE_HOME);

    if (!logged) {
      const clock = setTimeout(showLoginPopup, 750);
      return () => clearTimeout(clock);
    }
  }, []);

  return <Home />;
};
